import { useTranslation } from 'react-i18next';
import MantineGrid from '../../../../../../UI/MantineGrid/ManiteGrig';
import useHttp from '../../../../../../../hooks/use-http';
import { useContext, useEffect } from 'react';
import { urls } from './api/urls';
import { formatDateFromDB } from '../../../../../../../../utils/FormatDate';
import Sifra from '../../../../../../../../shared/components/Sifra';
import { TabContext } from '../../../../../../../Context/TabContext';

const ZSGridProvider = ({ idMasine }) => {
  const { t, i18n } = useTranslation();
  const { addTab } = useContext(TabContext);
  const { sendRequest, data, getData } = useHttp('');

  const handleOpenDetail = (item) => {
    // console.log(item);
    const tab = {
      title: 'Pregled zahteva',
      icon: 'fas fa-clipboard',
      type: 10014,
      data: item,
    };
    addTab(tab);
  };

  useEffect(() => {
    sendRequest({
      method: 'POST',
      url: urls.GET_ZAHTEVE,
      data: { id: idMasine, metadata: i18n.language },
    });
  }, [i18n.language]);

  const handleClickDok = async (item) => {
    console.log('ispitivanje stringa', item.ceoBrDok.includes('RNS'));
    const config = {
      method: 'POST',
      url: item.ceoBrDok.includes('RNS')
        ? urls.GET_RADNI_NALOG_ZA_ID
        : urls.GET_PONUDE_ID,
      data: { id: item.idDok },
    };
    const response = await getData(config);
    if (response.id > 0) {
      let tab = {};
      if (item.ceoBrDok.includes('RNS')) {
        tab = {
          title: 'Radni nalog',
          icon: 'fas fa-clipboard',
          type: 10012,
          data: response,
        };
      } else {
        tab = {
          title: 'Detalji ponude',
          icon: 'fas fa-file',
          type: 10017,
          data: { pregledMasina: response },
        };
      }
      addTab(tab);
    }
  };

  const columns = [
    {
      field: 'ceoBrDok',
      headerName: 'Broj zahteva',
      renderCell: (e) => (
        <Sifra
          displayValue={e.renderedCellValue}
          onClick={() => handleOpenDetail(e.row.original)}
        />
      ),
      // size: 300,
    },
    {
      field: 'naslov',
      headerName: 'Naslov',
      // size: 200,
    },
    {
      field: 'statusMasine',
      headerName: 'Status robot/alat',
      // size: 200,
    },
    {
      field: 'vrsteKvarova',
      headerName: 'Vrste kvara',
      // size: 200,
    },
    {
      field: 'datumSlanja',
      headerName: 'Datum',
      renderCell: (e) => {
        return formatDateFromDB(e.row.original.datumSlanja);
      },
      // size: 200,
    },
    {
      field: 'imeKorisnikaSlanjaZahteva',
      headerName: t('reportedBy'),
      // size: 150,
    },
  ];
  const columnsDetail = [
    {
      field: 'ceoBrDok',
      headerName: 'Broj dok',
      renderCell: (e) => (
        <Sifra
          displayValue={e.renderedCellValue}
          onClick={() => handleClickDok(e.row.original)}
        />
      ),
      // size: 300,
    },
    {
      field: 'datum',
      headerName: 'Datum',
      renderCell: (e) => {
        return formatDateFromDB(e.row.original.datum);
      },
      // size: 200,
    },
    {
      field: 'status',
      headerName: 'Status',
      // size: 200,
    },

    {
      field: 'napomena',
      headerName: 'Napomena',
      // size: 200,
    },
    // {
    //   field: 'title',
    //   headerName: t('title'),
    //   // size: 150,
    // },
    // {
    //   field: 'notificationDate',
    //   headerName: t('notificationDate'),
    //   // size: 150,
    // },
  ];
  return (
    <div
      style={{
        marginTop: '10px',
        height: 'fit-content',
        width: '99%',
      }}
    >
      <MantineGrid
        subRows="listaPovezenihDokumenata"
        enableTableDetail
        columns={columns}
        data={data}
        columnsDetail={columnsDetail}
      />
    </div>
  );
};

export default ZSGridProvider;
